/**
 * The shape of a game as the client sees it.
 *
 * Deliberately *not* a copy of the server's state. The server knows who
 * submitted every entry; this is what a particular member is allowed to know at
 * a particular moment, which is a much smaller thing. The whole game rests on
 * submitters staying hidden until the reveal, so the boundary is drawn here in
 * the types rather than left to each route to remember.
 */
/** Position of playback at a given server time, clamped to the clip. */
export function playbackPosition(playback, serverNow) {
    // A pending clip holds at its anchor: the room should see the bar sitting
    // still while the host's player spins up, not sliding through a song that
    // has not started.
    const elapsed = playback.isPlaying && !playback.pending ? serverNow - playback.anchorServerTime : 0;
    const raw = playback.anchorMediaPosMs + elapsed;
    return Math.min(playback.clipEndMs, Math.max(playback.clipStartMs, raw));
}
/** How far through the clip, 0 to 1, for a progress bar. */
export function playbackFraction(playback, serverNow) {
    const span = playback.clipEndMs - playback.clipStartMs;
    if (span <= 0)
        return 0;
    const position = playbackPosition(playback, serverNow) - playback.clipStartMs;
    return Math.min(1, Math.max(0, position / span));
}
/** True once the clip has run to its end. */
export function isClipFinished(playback, serverNow) {
    return playbackPosition(playback, serverNow) >= playback.clipEndMs;
}
//# sourceMappingURL=game.js.map